import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { setData } from 'src/storage/general.actions';

@Component({
  selector: 'app-lo-sentimos',
  templateUrl: './lo-sentimos.component.html',
  styleUrl: './lo-sentimos.component.scss'
})
export class LoSentimosComponent {
  private store = inject(Store);
  router = inject(Router);

  cleanStore(){
    this.store.dispatch(setData({
      key: 'Property',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'Tenant',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'PolicyHolder',
      value: undefined,
      merge: false
    }));
  }

  goBack(){
    this.cleanStore();
    window.location.href = 'https://www.sura.co/';
  }
}
